import React from 'react';

import { InstructionFlowState } from '@components/utilities/Bookings/InstructionFlow';
import { CustomsInstruction, CustomsInstructionFormLoose } from '@models/CustomsInstruction';
import { DeliveryInstruction, DeliveryInstructionFormLoose } from '@models/DeliveryInstruction';
import { InstructionStatus } from '@models/Instruction';
import { formatISOString } from '@utils/types';
import dayjs from 'dayjs';
import { FormikProps } from 'formik';

/**
 * save: 一時保存
 * submit: submit anyways (for some allowed errors)
 * confirm: set 確認済み
 * attempt: try to submit, if no error, just submit
 */
export type InstructionFormAction = 'save' | 'submit' | 'confirm' | 'attempt';

interface InstructionContextType {
  d2dNo: string;
  type: 'client' | 'admin';
  onGoBack: () => void;
  pendingUploads: number;
  setPendingUploads: React.Dispatch<React.SetStateAction<number>>;
  actionRef: React.MutableRefObject<InstructionFormAction>;
  flowState: InstructionFlowState;
  onChangeFlowState: (v: InstructionFlowState) => void;
  formikRef: React.MutableRefObject<FormikProps<any>>;
  formSubmitted: boolean;
  setFormSubmitted: (v: boolean) => void;
  isEditing: boolean;
  setIsEditing: (v: boolean) => void;
  isOverdue: boolean;
  isDialogOpen: boolean;
  setIsDialogOpen: (v: boolean) => void;
  requestDialogOpen: boolean;
  setRequestDialogOpen: (v: boolean) => void;
  requireChangeSuccess: boolean;
  setRequireChangeSuccess: (v: boolean) => void;
  currentStatus: InstructionStatus;
}
export interface DeliveryInstructionContextType extends InstructionContextType {
  deliveryInstruction: DeliveryInstruction;
  setDeliveryInstruction: (v: DeliveryInstruction) => void;
  initialValues: DeliveryInstructionFormLoose;
}

export const DeliveryInstructionContext = React.createContext<DeliveryInstructionContextType>(
  null as any,
);

export interface CustomsInstructionContextType extends InstructionContextType {
  customsInstruction: CustomsInstruction;
  setCustomsInstruction: (v: CustomsInstruction) => void;
  initialValues: CustomsInstructionFormLoose;
  useRcep: boolean;
}

export const CustomsInstructionContext = React.createContext<CustomsInstructionContextType>(
  null as any,
);

export const isInstructionOverdue = (deadline: string) =>
  dayjs(formatISOString(deadline, '16:00', 'Asia/Tokyo')).isBefore(dayjs());
